import { useEffect, useState } from "react";
import { Category } from "$types/CategoryType";
import { useReferencingCategoryQuery } from "$hooks/useCategoriesQuery";

const useReferencingCategory = (companyId: string) => {
  const { referencingCategory } = useReferencingCategoryQuery(companyId);
  const [hasReferencingCategory, setHasReferencingCategory] = useState<
    boolean | null
  >(null);
  const [currentCategory, setCurrentCategory] = useState<Category | null>(null);

  useEffect(() => {
    setHasReferencingCategory(!!referencingCategory);
    setCurrentCategory(referencingCategory || null);
  }, [referencingCategory]);

  return {
    hasReferencingCategory,
    loading: false,
    referencingCategory: currentCategory,
  };
};

export default useReferencingCategory;
